import { ApiActions } from "middleware/call-api";
import { ActionTypes, isExternalLinksLoading } from "../reducers/external-link-template.reducers";

export const setExternalLinkTemplateFormDisabled = disabled => ({
  type: ActionTypes.SET_EXTERNAL_LINK_TEMPLATE_FORM_DISABLED,
  payload: { disabled },
});

export const fetchExternalLinkTemplate = () => dispatch => {
  const url = "/systemConfiguration/externalLinkTemplate";

  return dispatch({
    [ApiActions.FETCH_FROM_API]: {
      endpoint: url,
      method: "GET",
      bailout: state => isExternalLinksLoading(state),
      entityType: "EXTERNAL_LINK_TEMPLATE",
    },
  });
};

export const saveExternalLinkTemplate = externalLinkTemplateToSave => async dispatch => {
  const response = await dispatch({
    [ApiActions.POST_TO_API]: {
      endpoint: "/systemConfiguration/externalLinkTemplate/save",
      body: { externalLinkTemplateToSave },
      types: [ActionTypes.SAVING_EXTERNAL_LINK_TEMPLATE, ActionTypes.SAVED_EXTERNAL_LINK_TEMPLATE, ActionTypes.ERROR_SAVING_EXTERNAL_LINK_TEMPLATE],
    },
  });

  return response;
};
